import * as types from './matrixservicerequestActionType';

//Get All Matrix Service Request
export const fetchMatrixServiceRequest = (payload) => ({
    type: types.FETCH_MATRIXSERVICE_REQUST,
    payload
});
export const fetchMatrixServiceRequestSuccess = (data) => ({
    type: types.FETCH_MATRIXSERVICE_SUCCESS,
    payload: data
});
export const fetchMatrixServiceRequestFailure = (error) => ({
    type: types.FETCH_MATRIXSERVICE_FAILURE,
    payload: error
});

//Get All Site Onboarding Palnner Dropdown list
export const siteonboardingplannerRequest = () => ({
    type: types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_REQUEST
});
export const siteonboardingplannerSuccess = (data) => ({
    type: types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_SUCCESS,
    payload: data
});
export const siteonboardingplannerFailure = (error) => ({
    type: types.SITEONBOARDINGPLANNER_DROPDOWN_VALUES_FAILURE,
    payload: error
});

//Get Worklist by RPCE
export const fetchworklistbyRPCEIDRequest = (rpceID) => ({
    type: types.GETWORKLISTBY_RPCEID_REQUEST,
    payload: rpceID
});
export const fetchworklistbyRPCEIDSuccess = (data) => ({
    type: types.GETWORKLISTBY_RPCEID_SUCCESS,
    payload: data
});
export const fetchworklistbyRPCEIDFailure = (error) => ({
    type: types.GETWORKLISTBY_RPCEID_FAILURE,
    payload: error
});

//Get Practice Name by Worklist ID
export const fetchpracticebyworklistidRequest = (worklistID) => ({
    type: types.GETPRACTICENAMEBY_WORKLIST_REQUEST,
    payload: worklistID
});
export const fetchpracticebyworklistidSuccess = (data) => ({
    type: types.GETPRACTICENAMEBY_WORKLIST_SUCCESS,
    payload: data
});
export const fetchpracticebyworklistidFailure = (error) => ({
    type: types.GETPRACTICENAMEBY_WORKLIST_FAILURE,
    payload: error
});

//Exporting Matrix Service Request Data
export const exportmatrixservicerequest = (payload) => ({
    type: types.EXPORT_MATRIXSERVICE_REQUEST,
    payload
});
export const exportmatrixservicesuccess = (data) => ({
    type: types.EXPORT_MATRIXSERVICE_SUCCESS,
    payload: data
});
export const exportmatrixservicefailure = (error) => ({
    type: types.EXPORT_MATRIXSERVICE_FAILURE,
    payload: error
});

//Add new Service Request
export const addmatrixserviceReequest = (payload) => ({
    type: types.ADDNEW_SERVICEREQUEST_REQUEST,
    payload
});
export const addmatrixservicesuccess = (data) => ({
    type: types.ADDNEW_SERVICEREQUEST_SUCCESS,
    payload: data
});
export const addmatrixservicefailure = (error) => ({
    type: types.ADDNEW_SERVICEREQUEST_FAILURE,
    payload: error
});

//Bulk Save Service Requests
export const bulksavematrixserviceRequest = (payload) => ({
    type: types.BULKSAVE_SERVICEREQUEST_REQUEST,
    payload
});
export const bulksavematrixserviceSuccess = (data) => ({
    type: types.BULKSAVE_SERVICEREQUEST_SUCCESS,
    payload: data
});
export const bulksavematrixserviceFailure = (error) => ({
    type: types.BULKSAVE_SERVICEREQUEST_FAILURE,
    payload: error
});

//Delete Service Request
export const deleteMatrixServiceRequest = (id, modifiedBy) => ({
    type: types.DELETEMATRIXSERVICE_REQUEST,
    payload: { id, modifiedBy }
});
export const deleteMatrixServiceSuccess = (id) => ({
    type: types.DELETEMATRIXSERVICE_SUCCESS,
    payload: id
});
export const deleteMatrixServiceFailure = (error) => ({
    type: types.DELETEMATRIXSERVICE_FAILURE,
    payload: error
});

// Get All Onboarding Site Demand Planner
export const fetchOnboardingSiteDemandPlannerRequest = () => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_REQUEST
});
export const fetchOnboardingSiteDemandPlannerSuccess = (data) => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_SUCCESS,
    payload: data
});
export const fetchOnboardingSiteDemandPlannerFailure = (error) => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_FAILURE,
    payload: error
});

// Get All Onboarding Site Demand Planner Legend List
export const fetchOnboardingSiteDemandPlannerLegendListRequest = () => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_REQUEST
});
export const fetchOnboardingSiteDemandPlannerLegendListSuccess = (data) => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_SUCCESS,
    payload: data
});
export const fetchOnboardingSiteDemandPlannerLegendListFailure = (error) => ({
    type: types.FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_FAILURE,
    payload: error
});

// Update Onboarding Site Demand Planner Data
export const updateOnboardingSiteDemandPlannerDataRequest = (payload) => ({
    type: types.UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_REQUEST,
    payload
});
export const updateOnboardingSiteDemandPlannerDataSuccess = (data) => ({
    type: types.UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_SUCCESS,
    payload: data
});
export const updateOnboardingSiteDemandPlannerDataFailure = (error) => ({
    type: types.UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_FAILURE,
    payload: error
});

